import { Designer } from "@brg/api";
import { Avatar, FlexBox } from "@brg/ui";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { computeDesigner } from "shared/helpers/computeData";
import { useTheme } from "styled-components";
import { AppTester, getContextFromAppName, getCurrentContextName } from "supporting";

import type { LinksItems } from "../../../../hooks/useServiceLinks";
import {
    AvatarContainer,
    InfoMsg,
    InfoWrapper,
    Name, ProjectsWrapper,
    ServiceLinks,
    ServiceLinksWrapper,
    ShowMoreMsg,
    Title, Wrapper
} from "./styles";
import { ServiceLinksList } from "./components";
import { ApplicationShared } from "core";

export const EMPTY_CONTENT_TAB = 'EMPTY_CONTENT_TAB';

const geplacedContextName = () => {
    const ctx = getCurrentContextName();

    switch (ctx) {
        case 'main':
            return AppTester.isDeziiign() ? 'deziiign' : 'geograffee'
        case 'galllleryart':
            return 'gallllery.art';
        case 'ageytomesh':
            return 'agey tomesh';
        case 'academy':
            return 'creativecity'
        default:
            return ctx;
    }
}


type TProps = {
    content: React.ReactNode,
    designer?: Designer<'Local'>,
    serviceLinks?: LinksItems,
}

export const NoProjectsContent: FC<TProps> = ({
    content,
    designer,
    serviceLinks,
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const computedDesigner = useMemo(() => computeDesigner(designer), [designer]);

    const context = getCurrentContextName()

    const currentSite = useMemo(() => {
        return window.location.hostname
    }, [])

    const aboutQuotesSanitized = useMemo(() => {
        const leftQuotes = typeof computedDesigner.about === 'string'? computedDesigner.about.replaceAll('&laquo;', '«') : ''
        const rightQuotes = typeof leftQuotes === 'string'? leftQuotes.replaceAll('&raquo;', '»') : ''
        return rightQuotes
  }, [computedDesigner?.about])

    // console.log('current',currentSite, ApplicationShared.application, serviceLinks)

    const InfoBlock = useMemo(() => (
            <InfoWrapper gy={16} gyMobile={16}>
                <FlexBox gx={8} gxMobile={8} align={'center'}>
                    <AvatarContainer>
                        <Avatar
                            imgBackColor={theme.app.backgroundColor}
                            {...computedDesigner}
                            fs={17}
                            shadow
                        />
                    </AvatarContainer>
                    <Name>{computedDesigner.fullName}</Name>
                </FlexBox>
                {computedDesigner.about?.length > 0 && <InfoMsg>{aboutQuotesSanitized}</InfoMsg>}
                {serviceLinks && (
                    <ServiceLinks directionMobile={'column'}>
                        <ShowMoreMsg>{t('pages.designer.view_users_projects') + (Object.entries(serviceLinks).length ? ` на ${currentSite}` : '')}</ShowMoreMsg>
                        {Object.entries(serviceLinks).length > 0 && <FlexBox>
                            <ShowMoreMsg>{t('pages.designer.view_users_others')}</ShowMoreMsg>
                            <ServiceLinksWrapper wrapMobile="wrap" id="links">
                                <ServiceLinksList serviceLinks={serviceLinks}/>
                            </ServiceLinksWrapper>
                        </FlexBox>}
                    </ServiceLinks>
                )}

            </InfoWrapper>
        ), [computedDesigner, theme, t, serviceLinks]);

    const TitleBox = useMemo(() => (
            <Title>
                {t('pages.designer.best_projects', {title: `${geplacedContextName()}`})}
            </Title>)
        , [t])

    return (
        <Wrapper>
            {InfoBlock}
            {TitleBox}
            <ProjectsWrapper>
                {content}
            </ProjectsWrapper>
        </Wrapper>
    )

}import { Designer } from "@brg/api";
import { Avatar, FlexBox } from "@brg/ui";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { computeDesigner } from "shared/helpers/computeData";
import { useTheme } from "styled-components";
import { AppTester, getContextFromAppName, getCurrentContextName } from "supporting";

import type { LinksItems } from "../../../../hooks/useServiceLinks";
import {
    AvatarContainer,
    InfoMsg,
    InfoWrapper,
    Name, ProjectsWrapper,
    ServiceLinks,
    ServiceLinksWrapper,
    ShowMoreMsg,
    Title, Wrapper
} from "./styles";
import { ServiceLinksList } from "./components";
import { ApplicationShared } from "core";

export const EMPTY_CONTENT_TAB = 'EMPTY_CONTENT_TAB';

const geplacedContextName = () => {
    const ctx = getCurrentContextName();

    switch (ctx) {
        case 'main':
            return AppTester.isDeziiign() ? 'deziiign' : 'geograffee'
        case 'galllleryart':
            return 'gallllery.art';
        case 'ageytomesh':
            return 'agey tomesh';
        case 'academy':
            return 'creativecity'
        default:
            return ctx;
    }
}


type TProps = {
    content: React.ReactNode,
    designer?: Designer<'Local'>,
    serviceLinks?: LinksItems,
}

export const NoProjectsContent: FC<TProps> = ({
    content,
    designer,
    serviceLinks,
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const computedDesigner = useMemo(() => computeDesigner(designer), [designer]);

    const context = getCurrentContextName()

    const currentSite = useMemo(() => {
        return window.location.hostname
    }, [])

    const aboutQuotesSanitized = useMemo(() => {
        const leftQuotes = typeof computedDesigner.about === 'string'? computedDesigner.about.replaceAll('&laquo;', '«') : ''
        const rightQuotes = typeof leftQuotes === 'string'? leftQuotes.replaceAll('&raquo;', '»') : ''
        return rightQuotes
  }, [computedDesigner?.about])

    // console.log('current',currentSite, ApplicationShared.application, serviceLinks)

    const InfoBlock = useMemo(() => (
            <InfoWrapper gy={16} gyMobile={16}>
                <FlexBox gx={8} gxMobile={8} align={'center'}>
                    <AvatarContainer>
                        <Avatar
                            imgBackColor={theme.app.backgroundColor}
                            {...computedDesigner}
                            fs={17}
                            shadow
                        />
                    </AvatarContainer>
                    <Name>{computedDesigner.fullName}</Name>
                </FlexBox>
                {computedDesigner.about?.length > 0 && <InfoMsg>{aboutQuotesSanitized}</InfoMsg>}
                {serviceLinks && (
                    <ServiceLinks directionMobile={'column'}>
                        <ShowMoreMsg>{t('pages.designer.view_users_projects') + (Object.entries(serviceLinks).length ? ` на ${currentSite}` : '')}</ShowMoreMsg>
                        {Object.entries(serviceLinks).length > 0 && <FlexBox>
                            <ShowMoreMsg>{t('pages.designer.view_users_others')}</ShowMoreMsg>
                            <ServiceLinksWrapper wrapMobile="wrap" id="links">
                                <ServiceLinksList serviceLinks={serviceLinks}/>
                            </ServiceLinksWrapper>
                        </FlexBox>}
                    </ServiceLinks>
                )}

            </InfoWrapper>
        ), [computedDesigner, theme, t, serviceLinks]);

    const TitleBox = useMemo(() => (
            <Title>
                {t('pages.designer.best_projects', {title: `${geplacedContextName()}`})}
            </Title>)
        , [t])

    return (
        <Wrapper>
            {InfoBlock}
            {TitleBox}
            <ProjectsWrapper>
                {content}
            </ProjectsWrapper>
        </Wrapper>
    )

}